import { render, staticRenderFns } from "./InventoryTemplate.vue?vue&type=template&id=11184aaa"
import script from "./InventoryTemplate.vue?vue&type=script&lang=js"
export * from "./InventoryTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports